<template>
  <div v-if="user!==null">
      <table class="table">
        <thead>
          <th>Mobile</th>
          <th>Balance</th>
          <th>Agent</th>
        </thead>
        <tbody>
          <tr>
              <td><b>{{user.mobile}}</b></td>
              <td>{{ user.balance }}</td>
              <td><b>{{user.is_agent===1? 'Yes' : 'No'}}</b></td>
          </tr>
        </tbody>
      </table>

    <b-row>
      <b-col>
        <Widget>
          <b-table
              id="patient-table"
              striped
              :items="table.patientInfo"
              :fields="table.fields"
              :current-page="table.currentPage"
              :per-page="table.perPage"
          >

            <!--        <template v-slot:cell(actions)="row">-->
            <!--          <b-button v-b-modal.details-modal variant="outline-success" size="sm" @click="selectCurrentPatient(row.index)" class="mr-1">Details</b-button>-->
            <!--          <b-button variant="outline-info" size="sm" @click="info(row.item, row.index)" class="mr-1" >Add Prescription</b-button>-->
            <!--          <b-button v-b-modal.update-patient-modal variant="outline-danger" size="sm" @click="selectCurrentPatient(row.index)" class="mr-1" >Edit</b-button>-->
            <!--        </template>-->

          </b-table>
          <b-pagination
              v-model="table.currentPage"
              :total-rows="table.totalRows"
              :per-page="table.perPage"
              aria-controls="patient-table"
          ></b-pagination>
        </Widget>
        <UserPaymentHistory></UserPaymentHistory>
      </b-col>
      <b-col>
        <PatiecntCheckUpHistory :user="this.idOfUser"></PatiecntCheckUpHistory>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import UserServices from '@/services/admin/user.service'
import PatiecntCheckUpHistory from "@/components/admin/CheckupHistory/PatiecntCheckUpHistory";
import UserPaymentHistory from "@/components/admin/PaymentsHistory/UserPaymentsHistory"

export default {
  name: "UserDetails",
  components:{
    PatiecntCheckUpHistory,
    UserPaymentHistory
  },
  data() {
    return {
      user: null,
      idOfUser: null,
      table: {
        patientInfo: [],
        fields: [
          {key: 'name', label: 'Name', sortable: true, class: 'text-center'},
          {key: 'age', label: 'Age', sortable: true, class: 'text-center'},
          {key: 'gender', label: 'Gender', sortable: true, class: 'text-center'},
          {key: 'blood_group', label: 'Blood Group', sortable: true, class: 'text-center'},
          {key: 'actions', label: 'Actions', sortable: true, class: 'text-center'},
        ],
        totalRows: 0,
        currentPage: 1,
        perPage: 3,
      },
    };
  },
  methods:{
    fetchPatients(id){
      UserServices.fetchPatient(id).then(response => {
        if(response.status == 200) {
          this.table.patientInfo = response.data;
          this.table.totalRows = response.data.length;
        }
        else{
          alert("Patient Info could not be Fetched!");
        }
      })
    },
  },
  mounted() {
    var user_id= window.location.href.split('=')[1];
    this.idOfUser=user_id;
    UserServices.fetchUserById(user_id)
    .then((response) =>{
      if(response.status === 200){
        this.user = response.data;
        this.fetchPatients(user_id);
      }
    })
  }
}
</script>

<style scoped>

</style>